import clsx from 'clsx';
import { IconProps } from '.';
import { useIconStyle } from 'components/commons';

function CloseIconModal({ className = '', style, color }: IconProps) {
  const classes = useIconStyle();

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      className={clsx(classes.root, {
        [className]: className.length > 0,
      })}
      style={style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.7071 11.9998L21.8536 21.1462C22.0488 21.3415 22.0488 21.6581 21.8536 21.8533C21.6583 22.0486 21.3417 22.0486 21.1464 21.8533L12 12.7069L2.85355 21.8533C2.65829 22.0486 2.34171 22.0486 2.14645 21.8533C1.95118 21.6581 1.95118 21.3415 2.14645 21.1462L11.2929 11.9998L2.14645 2.85334C1.95118 2.65808 1.95118 2.3415 2.14645 2.14623C2.34171 1.95097 2.65829 1.95097 2.85355 2.14623L12 11.2927L21.1464 2.14623C21.3417 1.95097 21.6583 1.95097 21.8536 2.14623C22.0488 2.3415 22.0488 2.65808 21.8536 2.85334L12.7071 11.9998Z'
        fill={color || '#3FA110'}
        />
    </svg>
  );
}

export default CloseIconModal;
